import lodash from 'lodash';
import {
    call,
    put,
    takeEvery,
    select,
} from 'redux-saga/effects';
import {
    updateBlemishReportSuccess,
    updateBlemishReportFailure,
} from '../../actions/questions_actions/update_blemish_report.actions';
import { UPDATE_BLEMISH_REPORT_REQUEST } from '../../constants/questions_constants/update_blemish_report.constants';
import { updateBlemishReport } from '../../../requests/leads_questions/update_blemish_report_request';
import { GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA } from '../../../../LeadPaymentApproval/constants';


function* updateBlemishReportRequest({ params, params2 }) {
    const store = yield select();
    const { valuations } = store.Leads.Lead_profile.Lead_valuations;
    const leadCustomer = store.Leads.Lead_profile.Ref_lead_customer.customer_details;
    const { result, options, error } = yield call(updateBlemishReport, params, params2);

    result
        ? yield put(updateBlemishReportSuccess(options))
        : yield put(updateBlemishReportFailure(error));

    if (result && lodash.get(params, 'question') === 'question_2') {
        yield put({
            type: GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            leadId: params.lead_id,
            valuationsFromProfile: valuations,
            blemQ2: options.questions.question_2,
            leadCustomer,
        });
    }
}

export default function* updateBlemishReportSaga() {
    yield takeEvery(UPDATE_BLEMISH_REPORT_REQUEST, updateBlemishReportRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/questions.sagas/update_blemish_report.saga.js